import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-3" }

import { InputRow, Combobox } from '@/components/ui/form';
    import { Textarea } from '@/components/ui/textarea';
    import { useI18n } from 'vue-i18n';
    import { useVoucherApprovedAccountsData } from '@/composables/useVoucherApprovedAccountsData';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VoucherMarkAsMissingForm',
  props: {
    form: {},
    companyId: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const { approvedAccounts, isPendingApprovedAccounts } = useVoucherApprovedAccountsData(
        props.companyId,
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "account",
      label: "vouchers.account_handle"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Combobox), {
          modelValue: _ctx.form.account,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.account) = $event)),
          options: _unref(approvedAccounts),
          "label-by": "number_and_name",
          "value-by": "accountNumber",
          "show-remove-button": false,
          loading: _unref(isPendingApprovedAccounts)
        }, null, 8, ["modelValue", "options", "loading"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "comment",
      label: "vouchers.comment_required"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Textarea), {
          id: "comment",
          modelValue: _ctx.form.comment,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.comment) = $event)),
          placeholder: _unref(t)('vouchers.comment')
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})